export default __webpack_public_path__ + "static/media/particlePlaylistSecondary.8e36ba1b.svg";